<template>
  <v-card class="assign-coupon" height="90vh">
    <v-card-title>{{ $t('admin_acc_coupon.edit_title') }}</v-card-title>
    <v-card-text>
      <div class="fill-height d-flex flex-column pt-2">
        <v-form ref="form">
          <v-row class="flex-grow-0">
            <v-col>
              <DatePickerInput :label="$t('admin_acc_coupon.valid_until')"
                               v-model="validUntil"
                               :rules="requiredRules"></DatePickerInput>
            </v-col>
          </v-row>
        </v-form>
        <v-row class="flex-grow-1">
          <v-col>
            <AdminCouponList full-height
                             hide-search
                             :extra-filters="{'id': couponIds}"></AdminCouponList>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary"
             @click="$emit('submit')">
        {{ $t('close') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary"
             @click="$refs.form.validate() && submit()">
        {{ $t('ok') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import {computed, onMounted, ref} from "@vue/composition-api";
import AdminCouponList from "@/components/acc_booking/AdminCouponList.vue";
import DatePickerInput from "@/components/DatePickerInput.vue";

export default {
  name: 'EditCouponValidUntilModal',
  components: {DatePickerInput, AdminCouponList},
  props: {
    couponIds: Array,
  },
  setup(props, {root, emit}) {
    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);

    const validUntil = ref(null);

    const submit = function () {
      root.$callAPI('aafb/admin/coupon/edit_valid_until/', {
        coupon_ids: props.couponIds,
        valid_until: validUntil.value,
      }, function (response) {
        emit('submit', true);
      })
    }

    return {
      requiredRules,
      validUntil,
      submit,
    }
  }
}
</script>

<style lang="less">
.assign-coupon {
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .v-card__title, .v-card__text, .v-card__actions {
    width: 100%;
  }

  .v-card__title, .v-card__actions {
    flex: 0 0 auto;
  }

  .v-card__text {
    flex: 1 1 0;
    overflow: auto;
  }
}


</style>
